import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default () => {
  (() => {
    let swiper = new Swiper('.js-spotlightSwiper', {
      modules: [Navigation],
      slidesPerView: "auto",
      spaceBetween: 16,
      speed: 500,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        resize: function (e) {
          let navBtn = e.navigation.nextEl;

          e.el.classList.toggle('-noPadding', navBtn.classList.contains('swiper-button-lock'));
        }
      }
    });

    if (swiper && typeof swiper.init === 'function') {
      swiper.init();
    }
  })();

  (() => {
    let swiper = new Swiper('.js-newsEvents', {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      breakpoints: {
        392: {
          slidesPerView: 2,
          spaceBetween: 32
        },
        768: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 40
        }
      },
      speed: 500,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });
  })();
}